import { render, staticRenderFns } from "./orderIndex.vue?vue&type=template&id=0f7d954c&scoped=true"
import script from "./orderIndex.vue?vue&type=script&lang=js"
export * from "./orderIndex.vue?vue&type=script&lang=js"
import style0 from "./orderIndex.vue?vue&type=style&index=0&id=0f7d954c&prod&lang=less&scoped=true"
import style1 from "./orderIndex.vue?vue&type=style&index=1&id=0f7d954c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d954c",
  null
  
)

export default component.exports